import {
  filterNoticeConversations,
  searchNoticeConversations,
  type NoticeConversation,
  type NoticeFilterId,
} from "./notice-conversations";
import {
  isNoticeSupportGroupsEmpty,
  searchNoticeSupportGroups,
  type NoticeSupportGroups,
} from "./notice-support-grouping";
import type { NoticeView } from "./notice-view";

export type NoticeDisplay =
  | { kind: "error" }
  | { kind: "loading" }
  | { kind: "empty"; searching: boolean }
  | { kind: "flat"; conversations: NoticeConversation[]; showBadge: boolean }
  | { kind: "grouped"; groups: NoticeSupportGroups; hideEmptyGroups: boolean };

export interface NoticeDisplayInputs {
  collapsed: boolean;
  view: NoticeView;
  loading: boolean;
  error: string | null;
  activeFilter: NoticeFilterId;
  searchQuery: string;
}

export function resolveNoticeDisplay({
  collapsed,
  view,
  loading,
  error,
  activeFilter,
  searchQuery,
}: NoticeDisplayInputs): NoticeDisplay {
  if (error !== null) return { kind: "error" };
  if (loading) return { kind: "loading" };

  // The search box only exists when expanded.
  const searching = !collapsed && searchQuery.trim() !== "";

  if (!collapsed && view.kind === "grouped") {
    const groups = searchNoticeSupportGroups(view.groups, searchQuery);
    if (searching && isNoticeSupportGroupsEmpty(groups)) {
      return { kind: "empty", searching: true };
    }
    return { kind: "grouped", groups, hideEmptyGroups: searching };
  }

  const conversations = collapsed
    ? view.conversations
    : searchNoticeConversations(
        filterNoticeConversations(view.conversations, activeFilter),
        searchQuery,
      );

  if (conversations.length === 0) {
    return { kind: "empty", searching };
  }

  return {
    kind: "flat",
    conversations,
    showBadge: !collapsed,
  };
}
